/**
 * @generated SignedSource<<1fa131b290fec3b636e57acba4718383>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OfferStatusRefetchQuery$variables = {
  id: string;
};
export type OfferStatusRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"OfferHistory_offerHistory">;
  } | null;
};
export type OfferStatusRefetchQuery = {
  variables: OfferStatusRefetchQuery$variables;
  response: OfferStatusRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OfferStatusRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OfferHistory_offerHistory"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OfferStatusRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfferStatusEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OfferStatus",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "guid",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Advertiser",
                        "kind": "LinkedField",
                        "name": "advertiser",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MoneyAmount",
                        "kind": "LinkedField",
                        "name": "pendingAmount",
                        "plural": false,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MoneyAmount",
                        "kind": "LinkedField",
                        "name": "approvedAmount",
                        "plural": false,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MoneyAmount",
                        "kind": "LinkedField",
                        "name": "rejectedAmount",
                        "plural": false,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "OfferStatusConnection",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "08bb8de395c9d03024e5eb07bd4c5df9",
    "id": null,
    "metadata": {},
    "name": "OfferStatusRefetchQuery",
    "operationKind": "query",
    "text": "query OfferStatusRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...OfferHistory_offerHistory\n    id\n  }\n}\n\nfragment OfferHistoryItem_offer on OfferStatus {\n  guid\n  title\n  advertiser {\n    name\n  }\n  pendingAmount {\n    formatted\n  }\n  approvedAmount {\n    formatted\n  }\n  rejectedAmount {\n    formatted\n  }\n  updatedAt\n}\n\nfragment OfferHistory_offerHistory on OfferStatusConnection {\n  edges {\n    node {\n      guid\n      ...OfferHistoryItem_offer\n      id\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "09ea33f5492cdc1a6bfcf77d2b2b623e";

export default node;
